<template>
  <div>
    <!-- Header: Car Info -->
    <div class="d-flex">
      <feather-icon
        icon="TruckIcon"
        size="19"
      />
      <h4 class="mb-0 ml-50">
        Car Information
      </h4>
    </div>

    <!-- Form: Personal Info Form -->
    <validation-observer ref="carInfoValidation">
      <b-form
        autocomplete="off"
        class="mt-1"
      >
        <b-row>
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="Car Number"
              label-for="car-number"
            >
              <b-row>
                <b-col md="3">
                  <validation-provider
                    #default="{ errors }"
                    name="Prifix Number"
                    rules="required"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                    >
                      <b-row>
                        <b-col
                          md="12"
                          class="pr-1"
                        >
                          <input
                            id="car-number"
                            v-model="prefixCarNumberData"
                            class="form-control"
                            maxlength="2"
                            type="text"
                            @input="validateInput"
                          >
                        </b-col>
                      </b-row>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                _
                <b-col md="7">
                  <validation-provider
                    #default="{ errors }"
                    name="Car Number"
                    rules="required"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                    >
                      <b-row>
                        <b-col
                          md="12"
                          class="pl-1"
                        >
                          <input
                            id="car-number"
                            v-model="suffixCarNumberData"
                            class="form-control"
                            type="text"
                            maxlength="10"
                            @input="validateInput"
                          >
                        </b-col>
                      </b-row>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col md="1">
                  <b-button
                    variant="primary"
                    class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                    @click="getDriverByCarNumber"
                  >
                    Search
                  </b-button>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <!-- Field: Car Make -->
          <b-col
            cols="12"
            md="6"
            lg="6"
          >
            <b-form-group
              label="Make"
              label-for="make"
            >
              <validation-provider
                #default="{ errors }"
                name="Make"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="make"
                    v-model="carData.make"
                    :disabled="disableMake"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Field: Model -->
          <b-col
            cols="12"
            md="6"
            lg="6"
          >
            <b-form-group
              label="Model"
              label-for="model"
            >
              <validation-provider
                #default="{ errors }"
                name="Model"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="model"
                    v-model="carData.model"
                    :disabled="disableModel"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="12"
            md="4"
            lg="4"
          >
            <b-form-group
              label="Car Type"
              label-for="car-type"
            >
              <validation-provider
                v-slot="{ errors }"
                name="Car Type"
                rules="required"
              >
                <v-select
                  id="search-state"
                  v-model="carData.carType"
                  :options="carTypeSelection"
                  name="carType"
                  :disabled="disableType"
                />
                <small class="text-danger">{{ errors[0] }} </small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="4"
            lg="4"
          >
            <b-form-group
              label="Fuel Type"
              label-for="fuel-type"
            >
              <validation-provider
                v-slot="{ errors }"
                name="Fuel Type"
                rules="required"
              >
                <v-select
                  id="search-state"
                  v-model="carData.fuelType"
                  :options="FuelTypeOptions"
                  name="fuelType"
                  :disabled="disableFType"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="4"
            lg="4"
          >
            <b-form-group
              label="Seats"
              label-for="seats"
            >
              <validation-provider
                v-slot="{ errors }"
                name="Seats"
                rules="required"
              >
                <v-select
                  id="search-state"
                  v-model="carData.noOfSeats"
                  :options="SeatsOptions"
                  name="noOfSeats"
                  :disabled="disableSeat"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <!-- Field: year -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="Year"
              label-for="year"
            >
              <validation-provider
                #default="{ errors }"
                name="Year"
                rules="required|between:1900,2050"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="year"
                    v-model="carData.year"
                    type="number"
                    number
                    :disabled="disableYear"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Field: color -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="Color"
              label-for="color"
            >
              <validation-provider
                #default="{ errors }"
                name="Color"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="color"
                    v-model="carData.color"
                    :disabled="disableColor"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Field: Car Number -->
        </b-row>

        <!-- submit buttons -->
        <b-button
          variant="primary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          @click="validationForm"
        >
          Save
        </b-button>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BButton,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import { ref } from '@vue/composition-api'
import vSelect from 'vue-select'
import { mapActions } from 'vuex'
import store from '@/store'
import { errorNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BButton,
    vSelect,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    driverData: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    console.log(this)
  },
  setup(props, ctx) {
    const carData = ref({})
    const prefixCarNumberData = ref('')
    const suffixCarNumberData = ref('')
    const disableMake = ref(false)
    const disableModel = ref(false)
    const disableType = ref(false)
    const disableFType = ref(false)
    const disableSeat = ref(false)
    const disableYear = ref(false)
    const disableColor = ref(false)
    const currentCarNumber = ref(null)
    const fetchCarDetailsByCarNumbr = async number => {
      try {
        carData.value = (
          await ctx.root.$store.dispatch('drivers/fetchCarDetailsByCarNumbr', {
            carNumber: number,
          })
        ).data.data
        console.log(carData.value)
        const conditions = [
          { check: carData.value.make !== null && carData.value.make.length > 0, action: () => { disableMake.value = true } },
          { check: carData.value.model !== null && carData.value.model.length > 0, action: () => { disableModel.value = true } },
          { check: carData.value.year !== 0 && carData.value.year.toString().length > 0, action: () => { disableYear.value = true } },
          { check: carData.value.carType !== null && carData.value.carType.length > 0, action: () => { disableType.value = true } },
          { check: carData.value.fuelType !== null && carData.value.fuelType.length > 0, action: () => { disableFType.value = true } },
          { check: carData.value.noOfSeats !== null && carData.value.noOfSeats.length > 0, action: () => { disableSeat.value = true } },
          { check: carData.value.color.length > 0, action: () => { disableColor.value = true } },
        ]

        conditions.forEach(({ check, action }) => {
          if (check) {
            action()
          }
        })
        const splitData = carData.value.carNumber.split('-')
        if (splitData.length > 1) {
          // eslint-disable-next-line prefer-destructuring
          prefixCarNumberData.value = splitData[0]
          // eslint-disable-next-line prefer-destructuring
          suffixCarNumberData.value = splitData[1]
        } else {
          prefixCarNumberData.value = carData.value.carNumber.slice(0, 2)
          suffixCarNumberData.value = carData.value.carNumber.slice(2, carData.value.carNumber.length)
        }
      } catch (error) {
        console.log(error)
      }
    }
    if (props.driverData.carId) {
      // carData.value = props.driverData.car
      currentCarNumber.value = props.driverData.car.carNumber
      fetchCarDetailsByCarNumbr(currentCarNumber.value)
    }

    const carTypeSelection = ref(['SEDAN', 'SUV', 'HATCHBACK', 'WAGON', 'CROSSOVER', 'MINIVAN', 'VAN', 'SCOOTER'])
    const FuelTypeOptions = ref(['ELECTRIC', 'HYBRID', 'FUEL'])
    const SeatsOptions = ref(['ONE', 'FOUR', 'SEVEN'])
    return {
      carData,
      currentCarNumber,
      required,
      carTypeSelection,
      FuelTypeOptions,
      SeatsOptions,
      prefixCarNumberData,
      suffixCarNumberData,
      disableMake,
      disableModel,
      disableType,
      disableFType,
      disableSeat,
      disableYear,
      disableColor,
    }
  },
  methods: {
    ...mapActions({
      addCar: 'drivers/addCar',
      updateCar: 'drivers/updateCar',
      getDriverCarCount: 'drivers/getDriverCarCount',
    }),
    async isCarNumberExists() {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async resolve => {
        try {
          await this.$store.dispatch('drivers/fetchCarDetailsByCarNumbr', {
            carNumber: this.carData.carNumber,
          })
          resolve(true)
        } catch (error) {
          resolve(false)
        }
      })
    },
    async validationForm() {
      const isValid = await this.$refs.carInfoValidation.validate()
      this.carData.carNumber = `${this.prefixCarNumberData}-${this.suffixCarNumberData}`
      if (this.suffixCarNumberData.length < 1) {
        return
      }
      if (this.suffixCarNumberData < 0 || this.prefixCarNumberData < 0) {
        errorNotification('You Can Not Add Negative Number ...')
      } else {
        console.log('')
        if (isValid) {
          const result = await this.$swal({
            title: 'Are you sure?',
            text: 'You want to apply this action?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, update it!',
            customClass: {
              confirmButton: 'btn btn-primary',
              cancelButton: 'btn btn-outline-danger ml-1',
            },
            buttonsStyling: false,
          })
          if (result.value) {
            try {
              const isCarNumberFound = await this.isCarNumberExists()
              if (!isCarNumberFound) {
                const temp = {
                  ...this.carData,
                }
                delete temp.id
                await this.addCar({
                  data: {
                    ...temp,
                    driverId: this.driverData.id,
                  },
                })
                this.$swal({
                  icon: 'success',
                  title: 'Saved',
                  text: 'Car Saved!',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
                return
              }
              if (this.driverData.carId) {
                if (
                  this.currentCarNumber
                  && this.currentCarNumber !== this.carData.carNumber
                ) {
                  const res = await this.getDriverCarCount(this.driverData.carId)
                  if (res.data.data.car_driver_count >= 1) {
                    await store.dispatch('drivers/updateDriverCar', {
                      carId: this.carData.id,
                      data: {
                        driverId: this.driverData.id,
                      },
                    })
                    if (this.carData.id !== undefined) {
                      await this.updateCar({
                        carId: this.carData.id,
                        data: {
                          ...this.carData,
                          driverId: this.driverData.id,
                        },
                      })
                    } else {
                      await this.updateCar({
                        carId: this.driverData.carId,
                        data: {
                          ...this.carData,
                          driverId: this.driverData.id,
                        },
                      })
                    }
                  } else {
                    await this.addCar({
                      data: {
                        ...this.carData,
                        driverId: this.driverData.id,
                      },
                    })
                  }
                } else {
                  await store.dispatch('drivers/updateDriverCar', {
                    carId: this.carData.id,
                    data: {
                      ...this.carData,
                      driverId: this.driverData.id,
                    },
                  })
                  await this.updateCar({
                    carId: this.carData.id,
                    data: {
                      ...this.carData,
                      driverId: this.driverData.id,
                    },
                  })
                }
              } else {
                await this.addCar({
                  data: {
                    ...this.carData,
                    driverId: this.driverData.id,
                  },
                })
              }
              this.checkDisableMethod(this.carData, false)
              this.$swal({
                icon: 'success',
                title: 'Saved',
                text: 'Car Saved!',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
              this.$emit('switch-to-documents-tab', 3)
            } catch (error) {
              console.log(error)
              this.$swal({
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong!',
                customClass: {
                  confirmButton: 'btn btn-danger',
                },
              })
              this.$swal({
                title: 'Error!',
                text: 'Car with this car number already exists.',
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
              })
            }
          }
        }
      }
    },
    validateInput() {
      this.suffixCarNumberData = this.suffixCarNumberData.replace(/\D/g, '')
      this.prefixCarNumberData = this.prefixCarNumberData.replace(/\D/g, '')
    },
    getDriverByCarNumber() {
      const carNumbers = `${this.prefixCarNumberData}-${this.suffixCarNumberData}`
      store.dispatch('drivers/fetchDriverByCarNumber', { carNumber: carNumbers })
        .then(response => {
          this.carData = response
          this.checkDisableMethod(this.carData, true)
        })
        .catch(error => {
          const message = error?.response?.data?.error?.detail || 'Something went wrong'
          errorNotification(message)
          this.carData = {}
          this.checkDisableMethod(this.carData)
        })
    },
    checkDisableMethod(carData, disable) {
      const fieldsToCheck = [
        { key: 'make', ref: 'disableMake' },
        { key: 'model', ref: 'disableModel' },
        { key: 'carType', ref: 'disableType' },
        { key: 'fuelType', ref: 'disableFType' },
        { key: 'noOfSeats', ref: 'disableSeat' },
        // The year field is treated specially to check for a number
        { key: 'year', ref: 'disableYear', checkNumber: true },
        { key: 'color', ref: 'disableColor' },
      ]

      if (disable) {
        fieldsToCheck.forEach(field => {
          this[field.ref] = false
        })
      } else {
        fieldsToCheck.forEach(field => {
          if (field.checkNumber) {
            // Special handling for year to check it is a number
            this[field.ref] = typeof carData[field.key] === 'number'
              && carData[field.key].toString().length > 0
          } else {
            this[field.ref] = carData[field.key]?.toString().length > 0
          }
        })
        if (carData.year === 0) {
          this.disableYear = false
        }
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
